document.querySelectorAll('.prc-rating-count-link').forEach(element => {
    element.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the default link behavior
        const targetId = this.getAttribute('href').substring(1); // Get the ID from the href (minus the #)
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            console.warn(`Element with ID '${targetId}' not found.`);
        }
    });
});